export const SAMPLING_STRATEGY_FETCH_SPECIMEN_AGGREGATE = 'SAMPLING_STRATEGY_FETCH_SPECIMEN_AGGREGATE';
export const SAMPLING_STRATEGY_RECEIVE_SPECIMEN_AGGREGATE = 'SAMPLING_STRATEGY_RECEIVE_SPECIMEN_AGGREGATE';
export const SAMPLING_STRATEGY_ERROR_SPECIMEN_AGGREGATE = 'SAMPLING_STRATEGY_ERROR_SPECIMEN_AGGREGATE';
